import { filterAssignments } from "./facets.js"; // Import facets and filterAssignments

export const hitsConfig = (categorySlug) => {
  const defaultConfig = filterAssignments.DEFAULT || {};
  const everyConfig = filterAssignments.EVERY || {};
  const categoryConfig = filterAssignments[categorySlug] || defaultConfig;

  const defaultHits = defaultConfig.displayHits || [];
  const everyHits = everyConfig.displayHits || [];
  const categoryHits = categoryConfig.displayHits || defaultHits;

  // Combine current category (or default) columns with columns from "Every" set.
  const allHitsConfig = [...categoryHits, ...everyHits].filter(
    (facet, index, self) => self.findIndex((f) => f.key === facet.key) === index
  );

  return allHitsConfig;
};

export const facetsConfig = (categorySlug) => {
  const defaultConfig = filterAssignments.DEFAULT || {};
  const everyConfig = filterAssignments.EVERY || {};
  const categoryConfig = filterAssignments[categorySlug] || defaultConfig;

  const defaultFacets = defaultConfig.displayFacets || [];
  const everyFacets = everyConfig.displayFacets || [];
  const categoryFacets = categoryConfig.displayFacets || defaultFacets;

  const allFacetsConfig = [...categoryFacets, ...everyFacets].filter(
    (facet, index, self) => self.findIndex((f) => f.key === facet.key) === index
  );

  return allFacetsConfig;
};

export const prepareUrl = (text) => {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, "-");
};

export const calcPrecision = (a) => {
  if (!isFinite(a)) return 0;
  let e = 1,
    p = 0;
  while (Math.round(a * e) / e !== a) {
    e *= 10;
    p++;
  }
  return p;
};

/** Max decimal places for range sliders; dynamic precision from data is capped here. */
const MAX_RANGE_SLIDER_PRECISION = 3;

export const getPrecision = (min, max) => {
  let precision = 0;
  let minPrecision = 0;
  let maxPrecision = 0;

  if (min > 0) {
    minPrecision = calcPrecision(min);
  }

  if (max > 0) {
    maxPrecision = calcPrecision(max);
  }
  precision = Math.max(minPrecision, maxPrecision);

  return Math.min(precision, MAX_RANGE_SLIDER_PRECISION);
};

export const normalizeIdentifier = (str) => {
  return str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^[-_]+|[-_]+$/g, "");
};
